import React from 'react'
import { ListingColumn } from './Listing'
import NoSort from '../../../images/icons/sort.svg'
import UpSort from '../../../images/icons/arrow_up.svg'
import DownSort from '../../../images/icons/arrow_down.svg'

import './SortFilter.css'

const noSortIcon = <img src={NoSort} width={9} />
const sortAscIcon = <img src={UpSort} width={9} />
const sortDescIcon = <img src={DownSort} width={9} />

interface SortFilter<T> {
	column: keyof T | string
	order: 'ASC' | 'DSC'
}

interface SortButtonProps<T> {
	setSort: React.Dispatch<React.SetStateAction<SortFilter<T>>>
	sort: SortFilter<T>
	columnName: keyof T | string
	preIconContent?: React.ReactNode
	sortJustify?: 'start' | 'end'
}

const SortButton = <T,>(props: SortButtonProps<T>) => {
	const setSortOrder = (column: keyof T | string) => {
		if (column !== props.sort.column) {
			props.setSort({ column, order: 'ASC' })
		} else {
			props.setSort({ column, order: props.sort.order === 'ASC' ? 'DSC' : 'ASC' })
		}
	}

	const columnSelected = props.sort.column === props.columnName

	const sortImage = columnSelected ? (props.sort.order === 'ASC' ? sortAscIcon : sortDescIcon) : noSortIcon

	return (
		<div className="sort-table-btn" onClick={() => setSortOrder(props.columnName)}>
			<div className={`d-flex align-items-center ${props.sortJustify ? 'justify-content-' + props.sortJustify : ''}`} style={{ gap: '0.5rem' }}>
				{props.preIconContent}
				{sortImage}
			</div>
		</div>
	)
}

const getSortFunction =
	<T,>(sort: SortFilter<T>, columns: ListingColumn<T>[]) =>
	(a: T, b: T) => {
		const sortColumn = columns.find((c) => c.sortColumnName === sort.column)
		if (sortColumn) {
			const valueA = sortColumn.value(a)
			const valueB = sortColumn.value(b)
			if (sortColumn.customSortCompare) {
				return valueA && valueB
					? sort.order === 'ASC'
						? sortColumn.customSortCompare(valueA, valueB)
						: sortColumn.customSortCompare(valueB, valueA)
					: 1
			} else {
				return valueA && valueB
					? sort.order === 'ASC'
						? String(valueA).localeCompare(String(valueB))
						: String(valueB).localeCompare(String(valueA))
					: 1
			}
		}
		return 0
	}

export { SortButton, getSortFunction }
export type { SortFilter, SortButtonProps }
